import React from 'react';
import { Link } from 'react-router-dom';
import { FMessage } from '../../hoc/IntlComponents';

const ApiRequestsGuide = ({ api_key }) => (
  <div className='guide'>
    <h6><b><FMessage id='transfer-by-api.nav.landing.guide.title'/></b></h6>

    <p><b><FMessage id='transfer-by-api.nav.api.guide.1'/>"offers"</b></p>
    <p className='code-text'>{`https://api.offerrum.com/webmaster/offers/?key=${api_key}&type=all`}</p>
    <p><FMessage id='transfer-by-api.nav.api.guide.2'/></p>

    <br/>

    {/* <p><b><FMessage id='transfer-by-api.nav.api.guide.1'/>"statistics"</b></p>
    <p className='code-text'>{'https://api.offerrum.com/statistics/?key=<apiKey>&type=countries'}</p>
    <p><FMessage id='transfer-by-api.nav.api.guide.4'/></p>

    <br/> */}

    <p className='warning-wrapper no-margin'>
      <FMessage id='transfer-by-api.nav.api.guide.3'/>
      <Link to='/faq/tools/api'>
        <FMessage id='transfer-by-api.guide.more-info-2'/>
      </Link>.
    </p>
  </div>
);

export default ApiRequestsGuide;